import {Injectable, NgZone} from '@angular/core';
import {MaintenanceStatusService} from 'src/app/infrastructure/service/maintenance-status.service';
import {Router} from 'src/app/infrastructure/router/router';
import {distinctUntilChanged} from 'rxjs/operators';
import MaintenanceRouteResolver from 'src/app/domain/service/route-resolver/maintenance-route-resolver.service';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceMonitorService {
  constructor(
    private maintenanceStatusService: MaintenanceStatusService,
    private router: Router,
    private zone: NgZone,
  ) {
  }

  startMonitoring(): void {
    this.maintenanceStatusService.isUnderMaintenance$()
      .pipe(
        distinctUntilChanged()
      )
      .subscribe(async (isUnderMaintenance) => {
        if (isUnderMaintenance) {
          await this.zone.run(async () => {
            const currentUrl = this.router.currentUrl().url;
            if (!currentUrl.includes('/maintenance')) {
              await this.router.navigate([MaintenanceRouteResolver.maintenanceUrl]);
            }
          });
        }
      });
  }
}
